import styled from "@emotion/styled";

export const FormGrid = styled.div(({ theme }) => ({
  display: "grid",
  gap: "15px",
  padding: "0 15px 15px",
  gridTemplateColumns: "minmax(150px, 1fr) minmax(150px, 1fr)",
  [`@media ${theme.deviceV2.lessThan.laptop}`]: {
    gridTemplateColumns: "minmax(150px, 1fr)",
  },
}));
